// 外部ファイル読み込み
import fadeInAnimation from '../animation/fadeInAnimation';
import ReadMoreLine from "../module/more";

/* global gsap, ScrollTrigger */

(() => {
	// eslint-disable-next-line no-console

	// ============================================
	// スクロールアニメーション
	// ============================================
	const scrollAnimation = () => {
		// ScrollTriggerを有効化
		gsap.registerPlugin(ScrollTrigger);

		// アニメーション対象要素を取得
		const track = document.querySelector("[data-image-animation]");

		// スクロール監視対象を取得
		const section = document.querySelector(".about");

		// 要素が存在しない場合は処理しない
		if (!track || !section) return;

		// GSAPのmatchMediaを作成
		// ブレークポイントが切り替わるたびに古いアニメーションを自動で破棄して再生成
		const mm = gsap.matchMedia();

		// ============================================
		// PC（768px以上）
		// ============================================
		mm.add("(min-width: 768px)", () => {

			// スクロール連動アニメーション
			gsap.to(track, {
				// X方向の移動量
				x: "45rem",

				// Y方向の移動量
				y: "-38rem",

				// スクロールと同期するためイージングなし
				ease: "none",

				// ScrollTrigger設定
				scrollTrigger: {
					// この要素を監視
					trigger: section,

					// section上端が画面下端に来たら開始
					start: "top bottom",

					// section下端が画面上端に来たら終了
					end: "bottom top",

					// スクロール量とアニメーションを同期
					scrub: true
				}
			});
		});

		// ============================================
		// SP（767px以下）
		// ============================================
		mm.add("(max-width: 767px)", () => {

			// スクロール連動アニメーション
			gsap.to(track, {
				// X方向の移動量
				x: "18rem",

				// Y方向の移動量
				y: "-9rem",

				// スクロールと同期するためイージングなし
				ease: "none",

				// ScrollTrigger設定
				scrollTrigger: {
					// この要素を監視
					trigger: section,

					// section上端が画面下端に来たら開始
					start: "top bottom",

					// section下端が画面上端に来たら終了
					end: "bottom top",

					// スクロール量とアニメーションを同期
					scrub: true
				}
			});
		});
	};

	// ============================================
	// クリックによるアンカーリンクのクラス付け替え
	// ============================================
	const ClickAnchorToggleClass = () => {
		// data-toggle-class を持つ要素をすべて取得
		const toggleLinks = document.querySelectorAll("[data-toggle-class]");
		const className = 'is-active';

		toggleLinks.forEach((link) => {
			link.addEventListener("click", () => {

				// 既にis-activeが付いている場合は何もしない
				if (link.classList.contains(className)) {
					return;
				}

				// 他の要素からis-activeを削除
				toggleLinks.forEach((item) => {
					item.classList.remove(className);
				});

				// クリックした要素にのみis-activeを付与
				link.classList.add(className);
			});
		});
	};

	// ============================================
	// スクロールによるアンカーリンクのクラス付け替え
	// ============================================
	const scrollAnchorToggleClass = () => {
		// 年別セクション
		const yearGroups = document.querySelectorAll(".timeline__year-group");

		// 年インデックスのリンク
		const anchorLinks = document.querySelectorAll("[data-toggle-class]");

		if (yearGroups.length && anchorLinks.length) {

			const observer = new IntersectionObserver(
				(entries) => {

					entries.forEach((entry) => {

						// 対象の年が画面上部付近に到達したら
						if (entry.isIntersecting) {

							const currentId = entry.target.id;

							// 既存の active を削除
							anchorLinks.forEach((link) => {
								link.classList.remove("is-active");
							});

							// 対応するアンカーだけ active
							const activeLink = document.querySelector(
								`[data-toggle-class][href="#${currentId}"]`
							);

							activeLink?.classList.add("is-active");
						}
					});
				},
				{
					// ビューポート上部付近を判定ラインにする
					root: null,
					rootMargin: "-20% 0px -70% 0px",
					threshold: 0
				}
			);

			yearGroups.forEach((group) => {
				observer.observe(group);
			});
		}
	};

	// ============================================
	// スクロールに合わせて年表の縦ラインを延長
	// ============================================
	const scrollAnchorProgress = () => {

		// SPはスルー
		if (!document.body.classList.contains('is-width-pc')) return;

		// タイムライン本体を配列に変換
		const years = [
			...document.querySelectorAll('.timeline__year-group')
		];

		// 縦ラインを持つPC用要素
		const anchorList =
			document.querySelector('.timeline__anchor-lst.is-pc-only');

		// PC用の年インデックス配列
		const anchors = anchorList
			? [...anchorList.querySelectorAll('.timeline__anchor-item')]
			: [];

		// 要素が存在しなければ終了
		if (!years.length || !anchors.length || !anchorList) {
			return;
		}

		// ----------------------------------------
		// アンカーリスト内の位置を取得
		// ----------------------------------------

		const getAnchorY = (anchor) => {

			let top = 0;
			let element = anchor;

			while (element && element !== anchorList) {

				top += element.offsetTop;
				element = element.offsetParent;
			}

			return top + anchor.offsetHeight / 2;
		};

		// ----------------------------------------
		// 最終アンカーまでの最大ライン長
		// ----------------------------------------

		const lastAnchor = anchors.at(-1);

		const maxLineHeight =
			getAnchorY(lastAnchor);

		// 最終年まで到達したか
		let isLastYearReached = false;

		/**
		 * 縦ラインの長さ更新
		 */
		const updateProgress = () => {

			// ----------------------------------------
			// 判定ライン
			// ----------------------------------------

			const triggerLine =
				window.innerHeight * 0;

			const lastYear =
				years[years.length - 1];

			const lastRect =
				lastYear.getBoundingClientRect();

			// ----------------------------------------
			// 最終年到達後の処理
			// ----------------------------------------

			if (isLastYearReached) {

				// 上に戻って最終年が
				// 判定ラインより下に戻ったら固定解除
				if (lastRect.top > triggerLine) {

					isLastYearReached = false;

				} else {

					// 最大値を維持
					anchorList.style.setProperty(
						'--progress-height',
						`${maxLineHeight}px`
					);

					return;
				}
			}

			// ----------------------------------------
			// 通常の進捗計算
			// ----------------------------------------

			const firstAnchor = anchors[0];

			let lineHeight =
				getAnchorY(firstAnchor);

			// ----------------------------------------
			// 現在どの年を読んでいるか探す
			// ----------------------------------------

			years.forEach((year, index) => {

				const nextYear = years[index + 1];

				// 最終年はここでは処理しない
				if (!nextYear) return;

				const rect =
					year.getBoundingClientRect();

				const nextRect =
					nextYear.getBoundingClientRect();

				// 判定ラインが
				// 現在の年〜次の年の間にあるか
				if (
					rect.top <= triggerLine &&
					nextRect.top >= triggerLine
				) {

					// 現在の年セクション内での進捗率
					const progress =
						(triggerLine - rect.top) /
						(nextRect.top - rect.top);

					// 現在の年インデックス
					const currentAnchor =
						anchors[index];

					// 次の年インデックス
					const nextAnchor =
						anchors[index + 1];

					// 現在の年の中心位置
					const currentY =
						getAnchorY(currentAnchor);
					// 次の年インデックス
					const nextY =
						getAnchorY(nextAnchor);

					// 現在の年→次の年へ補間
					lineHeight =
						currentY +
						(nextY - currentY) *
						Math.max(0, Math.min(progress, 1));
				}
			});

			// ----------------------------------------
			// 最終年まで到達した場合
			// ----------------------------------------

			if (lastRect.top <= triggerLine) {

				lineHeight = maxLineHeight;

				// 最終年到達済み
				isLastYearReached = true;
			}

			// ----------------------------------------
			// CSS変数へ反映
			// ----------------------------------------

			anchorList.style.setProperty(
				'--progress-height',
				`${lineHeight}px`
			);
		};

		// 初回実行
		updateProgress();

		// スクロール時
		window.addEventListener(
			'scroll',
			updateProgress,
			{ passive: true }
		);
	};

	// ============================================
	// もっと見る
	// ============================================
	const readMoreLineInit = () => {
		const dataAttrPref = "data-readmore-line";
		// ラッパー要素を取得
		document.querySelectorAll(`[${dataAttrPref}-wrap]`).forEach((wrap) => {
			const text = wrap.querySelector(`[${dataAttrPref}-text]`); // 表示するテキスト要素
			const textRwd = wrap.querySelector(`[${dataAttrPref}-text-rwd]`); // レスポンシブ時に表示するテキスト要素
			const btn = wrap.querySelector(`[${dataAttrPref}-btn]`); // トグルボタン
			const inActiveClassName = "is-inActive"; // トグル時に付与するクラス名
			const toggleClassName = wrap.getAttribute(`${dataAttrPref}-wrap`); // トグル時に付与するクラス名
			const numLines =
				parseInt(text.getAttribute(`${dataAttrPref}-text`), 10) || 12; // 表示する行数
			const numLinesRwd = textRwd
				? parseInt(textRwd.getAttribute(`${dataAttrPref}-text-rwd`), 10)
				: numLines; // レスポンシブ時に表示する行数
			const computedStyle = getComputedStyle(text); // テキスト要素のスタイルを取得
			const lineHeight = computedStyle.getPropertyValue("line-height"); // line-heightを取得
			const overflow = computedStyle.getPropertyValue("overflow"); // overflowを取得
			const openTxt = btn.textContent; //初期表示のテキストを取得

			// line-heightとoverflow: hiddenが指定されているかを確認
			if (lineHeight && overflow === "hidden") {
				new ReadMoreLine({
					wrap,
					text,
					textRwd,
					btn,
					inActiveClassName,
					toggleClassName,
					numLines,
					numLinesRwd,
					breakPointPc: 768, // 適宜変更可能
					openTxt: openTxt,
					closeTxt: "READ MORE",
				});
			}
		});
	};

	// ============================================
	// 実行
	// ============================================
	scrollAnimation();
	ClickAnchorToggleClass();
	scrollAnchorToggleClass();
	readMoreLineInit();
	// 外部ファイル実行
	fadeInAnimation();

	// ページの読み込みが完了した後に実行
	window.addEventListener('load', () => {
		scrollAnchorProgress();
	});

})();
